import { StatusBadge } from "../../../../../constants/statusConstants";
import InfoItem from "../../../components/InfoItem";

const TabAccountInfo = (response) => {
  return (
    <div className="">
      <div className="grid grid-cols-3 gap-6">
        <InfoItem label="Mã khách hàng" value={response.data.staffCode} />
        <InfoItem label="Tên đăng nhập" value={response.data.username} />
        <InfoItem
          label="Mật khẩu"
          value={response.data.password || "********"}
        />
        <InfoItem
          label="Phân quyền"
          value={
            response.data.role?.name === "Manager"
              ? "Quản lý"
              : response.data.role?.name === "Staff"
                ? "Nhân viên"
                : response.data.role?.name === "Admin"
                  ? "Admin"
                  : "Cộng tác viên"
          }
        />
        <InfoItem
          label="Trạng thái"
          value={<StatusBadge status={response.data.status} />}
        />
      </div>
    </div>
  );
};

export default TabAccountInfo;
